import { useCallback, useEffect, useState } from 'react';

interface UseWebMessageListenerPropsI {
  handleMessage: (event: MessageEvent<any>) => void;
}

function useWebMessageListener({ handleMessage }: UseWebMessageListenerPropsI) {
  const [enable, setEnable] = useState(false);

  function enableListener() {
    setEnable(true);
  }

  function disableListener() {
    setEnable(false);
  }

  const onMessageHandlerCallback = useCallback(handleMessage, [handleMessage]);

  function addMessageListenerForIframes() {
    window.addEventListener('message', onMessageHandlerCallback);
  }

  function removeMessageListenerForIframes() {
    window.removeEventListener('message', onMessageHandlerCallback);
  }

  function sendMessage(message: any, win) {
    if (!win) {
      return;
    }

    console.debug('DEBUG send message', message);
    //Send ready message to iframe
    win.postMessage(message, '*');
  }

  useEffect(() => {
    if (enable) {
      addMessageListenerForIframes();
    } else {
      removeMessageListenerForIframes();
    }

    return removeMessageListenerForIframes;
  }, [enable, onMessageHandlerCallback]);

  return {
    enable: enableListener,
    disable: disableListener,
    send: sendMessage,
  };
}

export default useWebMessageListener;
